import './app.scss';
import '@justgiving/loading/src/Loading.scss';

import { PAGES, customLinkCreationPath } from './constants/pages';
import React, { FunctionComponent, useContext, useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';

import { AuthContext } from '@justgiving/auth-react';
import CustomAmountDescriptions from './pages/CustomAmountDescriptions/CustomAmountDescriptions';
import CustomAmounts from './pages/CustomAmounts/CustomAmounts';
import DonationFrequency from './pages/DonationFrequency/DonationFrequency';
import { GivingCheckoutAccessWrapper } from './pages/NotAuthorised/GivingCheckoutAccessWrapper';
import Home from './pages/Home/Home';
import LinkDetails from './pages/LinkDetails/LinkDetails';
import { LinkLibrary } from './pages/LinkLibrary/LinkLibrary';
import Loader from '@justgiving/loading';
import { MenuBar } from './components/Menu/MenuBar';
import MultiPageGivingCheckout from './pages/MultiPageGivingCheckout/MultiPageGivingCheckout';
import PostDonationDetails from './pages/PostDonationDetails/PostDonationDetails';
import config from './config';
import { useCharityData } from './context/charityContext';
import { useSsoRedirection } from './hooks/useSsoRedirection';
import { useTranslation } from 'react-i18next';

export const App: FunctionComponent = () => {
  const { t } = useTranslation();
  const auth = useContext(AuthContext);
  const ssoUrl = useSsoRedirection();
  useEffect(() => {
    if (auth && ssoUrl) {
      window.location.assign(ssoUrl);
    }
  }, [auth, ssoUrl]);

  const { charity } = useCharityData();
  const charityNotApproved = charity && !charity.isApproved;
  useEffect(() => {
    if (charityNotApproved) {
      window.location.assign(`${config.base_url}/home`);
    }
  }, [charityNotApproved]);

  if (ssoUrl || !charity) {
    return (
      <div className="jg-space-mtxl">
        <Loader colour="grey" accessibleLabel={t('common.loading')} />
      </div>
    );
  }

  return (
    <GivingCheckoutAccessWrapper>
      <MenuBar />
      <Routes>
        <Route
          path={customLinkCreationPath}
          element={<MultiPageGivingCheckout />}
        >
          <Route path={PAGES.Frequency} element={<DonationFrequency />} />
          <Route path={PAGES.CustomAmounts} element={<CustomAmounts />} />
          <Route
            path={PAGES.Descriptions}
            element={<CustomAmountDescriptions />}
          />
          <Route
            path={PAGES.PostDonationDetails}
            element={<PostDonationDetails />}
          />
          <Route path={PAGES.LinkDetails} element={<LinkDetails />} />
          <Route path="*" element={<DonationFrequency />} />
        </Route>
        <Route path={PAGES.LinkLibrary} element={<LinkLibrary />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </GivingCheckoutAccessWrapper>
  );
};
